import type { RentReceiptFilters } from '../types/rentReceiptTypes'

export const rentReceiptKeys = {
  all: ['rentReceipts'] as const,

  lists: () => [...rentReceiptKeys.all, 'list'] as const,
  list: (filters: RentReceiptFilters) => [...rentReceiptKeys.lists(), filters] as const,

  details: () => [...rentReceiptKeys.all, 'detail'] as const,
  detail: (receiptId: string) => [...rentReceiptKeys.details(), receiptId] as const,

  /** Queue tab counts + the sidebar badge. */
  counts: () => [...rentReceiptKeys.all, 'counts'] as const,

  /** Same "depends on who's asking" reasoning as the distribution-run permission keys. */
  approvalPermission: (receiptId: string) =>
    [...rentReceiptKeys.all, 'approvalPermission', receiptId] as const,
}
